import { render, staticRenderFns } from "./DamagesCompensationTable.vue?vue&type=template&id=73434504"
import script from "./DamagesCompensationTable.vue?vue&type=script&lang=ts"
export * from "./DamagesCompensationTable.vue?vue&type=script&lang=ts"
import style0 from "./DamagesCompensationTable.vue?vue&type=style&index=0&id=73434504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports